import SVG from "react-inlinesvg";
import styled from "styled-components";
import SpinnerImg from "../../assets/images/spinner.svg";

export const SpinnerElement = styled(SVG).attrs({
  src: SpinnerImg,
})``;
